import React from "react";
import {
  Grid,
} from "@mui/material";
import { useStyles } from "./styles";
import { Formik } from "formik";
import * as Yup from "yup";
import useClients from "../../../hooks/store/clients";
import { useLocation, useNavigate } from "react-router-dom";
import { phoneRegExp } from "../../../utils/contsant";
import usePermissions from "../../../hooks/usePermissions";
import FormPageLayout from "../../../common/forms/FormPageLayout";
import FormikTextField from "../../../common/forms/FormikTextField";
import SubmitCancelActions from "../../../common/forms/SubmitCancelActions";

const ClientSchema = Yup.object().shape({
  name: Yup.string()
    .trim()
    .required("* Please enter name")
    .max(50, "name cannot exceed 50 characters"),
  email: Yup.string()
    .email("* Please enter valid email")
    .required("* Please enter email"),
  phone: Yup.string()
    .trim()
    .matches(phoneRegExp, {
      message: "* Phone number is not valid please try this (+xx)xxxxxxxxxx",
      excludeEmptyString: true,
    })
    .required("* Please enter mobile number"),
  // phone: Yup.string()
  //   .test(
  //     "phone",
  //     "Phone number is not valid. It should start with a country code followed by 10 digits.",
  //     (value) => {
  //       if (value && value.startsWith("+") && value.length === 13) {
  //         const countryCode = value.slice(1, 4);
  //         return countryCode && /^\d{1,3}$/.test(countryCode);
  //       }
  //       return false;
  //     }
  //   )
  //   .test("phone", "Phone number must be 10 digits long.", (value) => {
  //     if (value && value.length === 13) {
  //       const phone = value.slice(4);
  //       return phone && /^\d{10}$/.test(phone);
  //     }
  //     return false;
  //   })
  //   .required("Phone number is required"),
  address: Yup.string()
    .trim()
    .required("* Please enter address")
    .max(150, "Address cannot exceed 100 characters"),
});

const initValues = {
  name: "",
  email: "",
  phone: "",
  address: "",
  status: false,
};

function Index() {
  const location = useLocation();
  const classes = useStyles();
  const navigate = useNavigate();
  const isEditRoute = location.pathname === "/clients/editclient";
  const editingClient = location.state?.client || null;
  const hasEditableClient = Boolean(editingClient?.id);
  const {
    addClientDataAction,
    updateClientDataAction,
    addClientByClientAction,
  } = useClients();
  const { clientId, isClient } = usePermissions();
  const edit = isEditRoute && hasEditableClient;

  React.useEffect(() => {
    if (isEditRoute && !hasEditableClient) {
      navigate("/clients", { replace: true });
    }
  }, [hasEditableClient, isEditRoute, navigate]);

  const title = edit ? "Edit" : "Add New";

  const initialFormValues = React.useMemo(() => {
    if (edit && editingClient) {
      return {
        ...initValues,
        name: editingClient?.name || "",
        email: editingClient?.email || "",
        phone: editingClient?.phone || "",
        address: editingClient?.address || "",
        status: editingClient?.status === "Active" || false,
      };
    }

    return { ...initValues };
  }, [edit, editingClient]);

  if (isEditRoute && !hasEditableClient) {
    return null;
  }

  return (
    <>
      <Formik
        validationSchema={ClientSchema}
        initialValues={initialFormValues}
        enableReinitialize
        validateOnBlur={false}
        validateOnChange={false}
        onSubmit={async (values) => {
          let action;

          if (edit) {
            action = await updateClientDataAction({
              id: editingClient.id,
              name: values.name,
              address: values.address,
              email: values.email,
              phone: values.phone,
              status: "Active",
            });
          } else if (isClient && clientId) {
            action = await addClientByClientAction({
              clientIdLogin: clientId,
              name: values.name,
              address: values.address,
              email: values.email,
              phone: values.phone,
            });
          } else {
            action = await addClientDataAction({
              name: values.name,
              address: values.address,
              email: values.email,
              phone: values.phone,
            });
          }

          if (action?.meta?.requestStatus === "fulfilled") {
            navigate("/clients");
          }
        }}
      >
        {(formik) => {
          const {
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            values,
          } = formik;
          const textFieldProps = {
            values,
            handleChange,
            handleBlur,
            errors,
            touched,
            className: classes.textfield,
            inputErrorClassName: classes.inputError,
            inputNoErrorClassName: classes.inputNoError,
            errorClassName: classes.error,
          };

          return (
            <FormPageLayout
              title={`${title} Client`}
              cardTitle="Client Details"
              formProps={{ onSubmit: handleSubmit }}
              cardClassName={classes.Card}
              headerClassName={classes.heading}
              actions={
                <SubmitCancelActions
                  buttonClassName={classes.button}
                  onCancel={() => navigate("/clients")}
                  submitLabel={`${title} Client`}
                />
              }
            >
              <Grid container spacing={2} justifyContent="start">
                <Grid item xs={12} sm={6}>
                  <FormikTextField
                    {...textFieldProps}
                    name="name"
                    label="Name"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormikTextField
                    {...textFieldProps}
                    name="email"
                    label="Email Address"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormikTextField
                    {...textFieldProps}
                    name="phone"
                    label="Phone Number"
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <FormikTextField
                    {...textFieldProps}
                    name="address"
                    label="Address"
                    type="text"
                    minRows={4}
                    multiline
                  />
                </Grid>
              </Grid>
            </FormPageLayout>
          );
        }}
      </Formik>
    </>
  );
}

export default Index;
